<template>
  <el-dialog
    :class="[currentTheme]"
    :visible.sync="dialogVisible"
    class="no-header-dialog tb-screen-dialog"
    :close-on-click-modal="false"
    :show-close="false"
    width="100%"
    :fullscreen="true"
    append-to-body
  >
    <xr-loading :is-loading="loading"></xr-loading>

    <div class="tb-screen-container">
      <el-form ref="dataForm" class="main-form" :model="temp" :rules="rules" label-width="150px" size="small">
        <!-- 顶部标题区域 -->
        <el-card shadow="never" class="header-card">
          <div class="header-wrap">
            <div class="title-text">
              <strong>老年人生活自理能力评估表</strong>
            </div>
            <div class="btn-group">
              <div class="th-button" @click="submitForm">
                <i class="wk wk-preservation"></i><span>保存</span>
              </div>
              <div class="th-button th-button-info" @click="back()">
                <i class="wk wk-back"></i><span>关闭</span>
              </div>
            </div>
          </div>
        </el-card>

        <div class="collapse-scroll-wrap">
          <el-collapse class="normal-el-collapse screen-collapse" v-model="activeNames">
            <el-collapse-item name="1">
              <template slot="title"><span class="collapse-title">评估表</span></template>
              <div class="collapse-body">

                <!-- 顶部说明 + 评估日期/评估人/评估结果 -->
                <div class="assess-tip">
                  该表为自评表，根据下表中5个方面进行评估，将各方面判断评分汇总后，0-3分者为可自理；4-8分者为轻度依赖；9-18分者为中度依赖；≥19分者为不能自理。
                </div>

                <el-row :gutter="24" class="assess-header">
                  <el-col :span="8">
                    <el-form-item label="评估日期">
                      <el-date-picker
                        v-model="temp.assessDate"
                        type="date"
                        placeholder="选择日期"
                        style="width:100%"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="评估人">
                      <el-select v-model="temp.assessor" placeholder="请选择" style="width:100%">
                        <el-option
                          v-for="item in assessorList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="评估结果">
                      <el-select v-model="assessResult" placeholder="评估结果" style="width:100%" disabled>
                        <el-option label="可自理" value="可自理" />
                        <el-option label="轻度依赖" value="轻度依赖" />
                        <el-option label="中度依赖" value="中度依赖" />
                        <el-option label="不能自理" value="不能自理" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- 评估表 -->
                <el-table
                  :data="tableData"
                  border
                  :span-method="spanMethod"
                  class="assess-table"
                >
                  <el-table-column
                    prop="itemName"
                    label="评估事项、内容与评分"
                    width="240"
                    align="center"
                  />

                  <el-table-column label="程度等级" align="center">
                    <el-table-column
                      v-for="level in levelColumns"
                      :key="level.prop"
                      :label="level.label"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <!-- 评分行显示单选框 -->
                        <el-radio
                          v-if="scope.row.rowType === 'score'"
                          v-model="scope.row[level.prop]"
                          :label="level.score"
                          @change="handleScoreChange(scope.row, level.score)"
                        >
                          {{ level.score }}
                        </el-radio>
                        <!-- 描述行显示文字 -->
                        <span v-else>{{ scope.row[level.prop + 'Desc'] }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>

                  <el-table-column
                    prop="score"
                    label="判断评分"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.rowType === 'score' && scope.row.score !== ''"
                        class="score-text"
                      >
                        {{ scope.row.score }}
                      </span>
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 总评分 -->
                <div class="total-score-row">
                  <span class="total-label">总评分</span>
                  <span class="total-value">{{ totalScore }}</span>
                </div>

              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "elderlySelfCareAssess",
  data() {
    return {
      dialogVisible: false,
      activeNames: ['1'],
      rules: {},
      loading: false,
      isSaving: false,

      // 评估人下拉（按你项目实际情况调整）
      assessorList: [
        { label: '陈文福1', value: '陈文福1' }
      ],

      // 顶部/底部字段
      temp: {
        id: '',
        archiveId: '',
        assessDate: '',
        assessor: '',
        remark: ''
      },

      // 表格数据：每一项包含描述行 + 评分行
      tableData: [
        {
          rowType: 'desc',
          itemName: '(1) 进餐：使用餐具将饭菜送入口、咀嚼、吞咽等活动',
          ableDesc: '独立完成',
          mildDesc: '——',
          moderateDesc: '需要协助，如切碎、搅拌食物等',
          severeDesc: '完全需要帮助'
        },
        {
          rowType: 'score',
          itemName: '',
          able: '',
          mild: '',
          moderate: '',
          severe: '',
          score: ''
        },

        {
          rowType: 'desc',
          itemName: '(2) 梳洗：梳头、洗脸、刷牙、剃须洗澡等活动',
          ableDesc: '独立完成',
          mildDesc: '能独立地洗头、梳头、洗脸、刷牙、剃须等；洗澡需要协助',
          moderateDesc: '在协助下和适当的时间内，能完成部分梳洗活动',
          severeDesc: '完全需要帮助'
        },
        {
          rowType: 'score',
          itemName: '',
          able: '',
          mild: '',
          moderate: '',
          severe: '',
          score: ''
        },

        {
          rowType: 'desc',
          itemName: '(3) 穿衣：穿衣裤、袜子、鞋子等活动',
          ableDesc: '独立完成',
          mildDesc: '——',
          moderateDesc: '需要协助，在适当的时间内完成部分穿衣',
          severeDesc: '完全需要帮助'
        },
        {
          rowType: 'score',
          itemName: '',
          able: '',
          mild: '',
          moderate: '',
          severe: '',
          score: ''
        },

        {
          rowType: 'desc',
          itemName: '(4) 如厕：小便、大便等活动及自控',
          ableDesc: '不需协助，可自控',
          mildDesc: '偶尔失禁，但基本上能如厕或使用便具',
          moderateDesc: '经常失禁，在很多提示和协助下尚能如厕或使用便具',
          severeDesc: '完全失禁，完全需要帮助'
        },
        {
          rowType: 'score',
          itemName: '',
          able: '',
          mild: '',
          moderate: '',
          severe: '',
          score: ''
        },

        {
          rowType: 'desc',
          itemName: '(5) 活动：站立、室内行走、上下楼梯、户外活动',
          ableDesc: '独立完成所有活动',
          mildDesc: '借助较小的外力或辅助装置能完成站立、行走、上下楼梯等',
          moderateDesc: '借助较大的外力才能完成站立、行走，不能上下楼梯',
          severeDesc: '卧床不起，活动完全需要帮助'
        },
        {
          rowType: 'score',
          itemName: '',
          able: '',
          mild: '',
          moderate: '',
          severe: '',
          score: ''
        }
      ],

      // 4 个等级列，列名 + 该列对应的分数
      levelColumns: [
        { prop: 'able',     label: '可自理',   score: 0  },
        { prop: 'mild',     label: '轻度依赖', score: 0  }, // 注意：轻度依赖分数各题不同，这里动态处理
        { prop: 'moderate', label: '中度依赖', score: 0  },
        { prop: 'severe',   label: '不能自理', score: 0  }
      ]
    };
  },
  computed: {
    currentTheme() {
      return this.$store.getters.themeType;
    },

    // 汇总所有评分
    totalScore() {
      return this.tableData
        .filter(row => row.rowType === 'score')
        .reduce((sum, row) => sum + (Number(row.score) || 0), 0);
    },

    // 根据总分得出评估结果
    assessResult() {
      const score = this.totalScore;
      if (score >= 19) return '不能自理';
      if (score >= 9)  return '中度依赖';
      if (score >= 4)  return '轻度依赖';
      return '可自理';
    }
  },
  methods: {
    init(archiveId) {
      this.resert();
      this.temp.archiveId = archiveId;
      this.dialogVisible = true;
      this.$nextTick(() => {
        // 如需从后端拉取已有数据，可在这里调用
        // this.getPageInfo();
      });
    },

    // 单选项变化时，同步到该行 score 字段
    handleScoreChange(row, score) {
      row.score = score;
    },

    // 表格合并：把「描述行 + 评分行」的第一列合并
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 第一列（评估事项、内容与评分）合并相邻两行
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return { rowspan: 2, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },

    submitForm() {
      if (this.isSaving) return;
      this.isSaving = true;

      // 组装提交数据，按你后端接口需要调整
      const params = {
        ...this.temp,
        totalScore: this.totalScore,
        assessResult: this.assessResult,
        details: this.tableData
          .filter(row => row.rowType === 'score')
          .map((row, idx) => ({
            itemIndex: idx + 1,
            score: row.score
          }))
      };

      return this.request({
        method: 'post',
        url: '/web/service?method=elderlySelfCareAssess_save',
        params
      }).then((response) => {
        if (response.code != '0') {
          this.$message.error(response.msg);
          this.isSaving = false;
          return false;
        }
        this.$message({
          message: '操作成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.dialogVisible = false;
            this.$emit('refreshData');
            this.isSaving = false;
          }
        });
      }).catch(() => {
        this.isSaving = false;
      });
    },

    back() {
      this.dialogVisible = false;
      this.$emit('refreshData');
    },

    resert() {
      this.temp.id = '';
      this.temp.archiveId = '';
      this.temp.assessDate = '';
      this.temp.assessor = '';
      this.temp.remark = '';
      this.tableData.forEach(row => {
        if (row.rowType === 'score') {
          row.able = '';
          row.mild = '';
          row.moderate = '';
          row.severe = '';
          row.score = '';
        }
      });
    }
  }
};
</script>

<style scoped>
.tb-screen-dialog >>> .el-dialog__wrapper {
  overflow: hidden;
}
.tb-screen-dialog >>> .el-dialog {
  margin: 0;
  height: 100vh;
  overflow: hidden;
}
.tb-screen-dialog >>> .el-dialog__body {
  padding: 0;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
}

.tb-screen-container {
  height: 100vh;
  padding: 16px 24px;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.main-form {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header-card {
  flex-shrink: 0;
  padding: 3px 16px;
}
.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-group {
  display: flex;
}

.collapse-scroll-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 12px;
}
.collapse-scroll-wrap::-webkit-scrollbar { width: 6px; }
.collapse-scroll-wrap::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}
.collapse-scroll-wrap::-webkit-scrollbar-track { background: transparent; }

.screen-collapse { border-top: none; margin-top: 0; }
.screen-collapse >>> .el-collapse-item__header {
  background: #f5f7fa;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  border-bottom: 1px solid #e8ebf0;
  font-size: 14px;
}
.screen-collapse >>> .el-collapse-item__arrow { margin: 0 8px 0 auto; }
.screen-collapse >>> .el-collapse-item__wrap { border-bottom: 1px solid #e8ebf0; }
.collapse-body { padding: 16px 16px 4px 16px; }

.main-form >>> .el-form-item { margin-bottom: 14px; }
.main-form >>> .el-form-item__label {
  padding-right: 8px;
  line-height: 32px;
}

/* 顶部说明 */
.assess-tip {
  font-size: 13px;
  color: #606266;
  line-height: 22px;
  margin-bottom: 12px;
}

.assess-header {
  margin-bottom: 8px;
}

/* 表格样式 */
.assess-table {
  margin-top: 4px;
}
.assess-table >>> .el-table__header th {
  background: #f5f7fa;
  color: #303133;
  font-weight: 600;
}
.assess-table >>> .el-table__body td {
  padding: 6px 0;
}

/* 判断评分列红字 */
.score-text {
  color: #f5222d;
  font-size: 16px;
  font-weight: bold;
}

/* 总评分行 */
.total-score-row {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #ebeef5;
  padding-top: 12px;
}
.total-label {
  font-size: 14px;
  color: #303133;
  margin-right: 16px;
}
.total-value {
  font-size: 18px;
  color: #f5222d;
  font-weight: bold;
  min-width: 60px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/ph/archive/medical/evaluate/elderly-self-care.vue